<template>  
    <div class="fullwidth">
        <login-form/> 
    </div>
</template>

<script> 
import loginForm from '@/components/forms/auth/login'; 

export default {
    name: 'auth-login',
    components: { 
        loginForm
    }
}
</script>